module.exports = __webpack_public_path__ + "static/media/reward-third.1639468d.svg";